export default __webpack_public_path__ + "static/media/Corporate_Presentation_2023.91565ad0.pdf";